// extracted by mini-css-extract-plugin
export default {"section":"SettingsSection_section__ay5xO"};